const filterButton = document.querySelectorAll('.filters__filter > button');
const listButton = document.querySelectorAll('.filters__filter-info > button')

filterButton.forEach(button => {
  button.addEventListener('click', () => {
    const parent = button.parentNode;

    if(parent.classList.contains('activeFilter')) {
      parent.classList.remove('activeFilter')
    } else {
      filterButton.forEach(btn => btn.parentNode.classList.remove('activeFilter'));
      parent.classList.add('activeFilter')
    }

  })
})

listButton.forEach(button => {
  button.addEventListener('click', () => {

    const parent = button.closest('.filters__filter');
    const buttonClick = parent.querySelector('.filters__filter button')

    buttonClick.innerHTML  = `${button.innerText} <span></span>`;

    parent.classList.remove('activeFilter')
  })
})

const buttonPoint = document.querySelectorAll('.filters__cards-buttons button');

buttonPoint.forEach(button => {
  button.addEventListener('click', () => {
    button.classList.toggle('activeButtonCard')
  })
})
